import { GetterTree } from 'vuex'
import { Things } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Things, RootState> = {
  getThings: state => {
    return state.filterThings.sort((a, b) => {
      const x = a.name.toUpperCase(),
        y = b.name.toUpperCase()
      return x == y ? 0 : x > y ? 1 : -1
    })
  },
  filteredThingsByLiveTrackingService: (state, getters) => {
    return getters.getThings.filter(entity =>
      entity.serviceList.some(
        service =>
          service.name === 'mrn:service:live_tracking' &&
          service.status !== 'inactive'
      )
    )
  },
  getResponseError: state => {
    return state.responseError
  },
  getResponseMessage: state => {
    return state.responseMessage
  },
  getCurrentThing: state => {
    return state.currentThing
  },
  getContactEmergencyFromPerson(state) {
    return state.contactEmergencyFromPerson
  }
}